import { render, staticRenderFns } from "./ParticipantDeviceAssignment.vue?vue&type=template&id=98f64c46&scoped=true&"
import script from "./ParticipantDeviceAssignment.vue?vue&type=script&lang=ts&"
export * from "./ParticipantDeviceAssignment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f64c46",
  null
  
)

export default component.exports